var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTablet(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 32,
    width: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cy: 16,
    cx: 16,
    fill: "#FFF",
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.188a.563.563 0 110 1.125.563.563 0 010-1.125zM11.5 9.813v11.25h9V9.813zm-.281-.563h9.562c.155 0 .282.126.282.281v11.813a.281.281 0 01-.282.281H11.22a.281.281 0 01-.281-.281V9.53c0-.155.125-.281.28-.281zM9.813 8.125v15.75h12.374V8.125zM9.25 7h13.5c.31 0 .563.251.563.563v16.875a.562.562 0 01-.563.562H9.25a.562.562 0 01-.563-.563V7.563c0-.31.252-.562.563-.562z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default ForwardRef;